import React from "react";
import ControlCenterComponent from "../components/ControlCenterComponent";

const ControlCenter = () => {
  return (
    <div>
      <ControlCenterComponent />
    </div>
  );
};

export default ControlCenter;
